

export const calculateDiscountRate = (originalPrice, discountedPrice) => {
    if (originalPrice > 0 && originalPrice > discountedPrice) {
        return Math.floor(100.0 * (originalPrice - discountedPrice) / originalPrice);
    }
    return 0;
};
